import { DEFAULT_ZOOM_LEVEL } from 'context/ZoomContext';

const getSafeZoomLevel = (zoomLevel: number): number => (
  Number.isFinite(zoomLevel) && zoomLevel > 0 ? zoomLevel : DEFAULT_ZOOM_LEVEL
);

export const getZoomAdjustedPx = (value: number, zoomLevel: number): string => (
  `calc(${value}px / ${getSafeZoomLevel(zoomLevel)})`
);

export const getZoomAdjustedCssValue = (value: string, zoomLevel: number): string => (
  `calc((${value}) / ${getSafeZoomLevel(zoomLevel)})`
);
